import script from "./TheLoaderComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./TheLoaderComponent.vue?vue&type=script&setup=true&lang=js"

import "./TheLoaderComponent.vue?vue&type=style&index=0&id=97bb1d5a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-97bb1d5a"]])

export default __exports__